import shared from "emun.report/report.config.es6"; //get shared

export const customerStatuses = [
  {
    value: "Active",
    label: "Active"
  },
  {
    value: "InActive",
    label: "InActive"
  }
];

export const defaultOrderStatuses = ["Open", "Completed", "Review"];
export const exportedOrdersOnly = false;
export const insideSales = "insideSalesAll";
export const vendorsShowInactive = "vendorsShowInactive";

shared.reports.push(
  {
    name: "Customers_DealerListCustomFilter",
    reportName: "DealerListCustomFilter",
    params: ["customerStatuses","insideSalesAll", "output"]
  }
);

for (const r of shared.reports) {
  if (r.name === "SalesOrders_OrderSummary") {
    r.defaultParams[0].value = defaultOrderStatuses;
    r.defaultParams[1].value = exportedOrdersOnly;
    r.params.push(vendorsShowInactive);
  }
  if (r.name === "SalesOrders_OrderDetails") {
    r.defaultParams[0].value = defaultOrderStatuses;
    r.defaultParams[1].value = exportedOrdersOnly;
    r.params.push(vendorsShowInactive);
  }
  if (r.name === "SalesOrders_OrderSummaryByDate") {
    r.defaultParams[0].value = defaultOrderStatuses;
    r.params.push(vendorsShowInactive);
  }
  if (r.name === "SalesOrders_ProductSalesByStatus") {
    r.defaultParams[0].value = defaultOrderStatuses;
    r.defaultParams[1].value = exportedOrdersOnly;
    r.params.push(vendorsShowInactive);
  }
  if (r.name === "SalesOrders_TopSellingItems") {
    r.defaultParams[0].value = defaultOrderStatuses;
    r.defaultParams[1].value = exportedOrdersOnly;
    r.params.push(vendorsShowInactive);
  }
  if (r.name === "SalesOrders_TotalSalesByDate") {
    r.defaultParams[0].value = defaultOrderStatuses;
    r.defaultParams[1].value = exportedOrdersOnly;
    r.params.push(vendorsShowInactive);
  }
  if (r.name === "DataAnalysis_SalesOrderSummary") {
    r.defaultParams[0].value = defaultOrderStatuses;
    r.defaultParams[1].value = exportedOrdersOnly;
    r.params.push(vendorsShowInactive);
  }
  if (r.name === "DataAnalysis_ProductSummary") {
    r.defaultParams[0].value = defaultOrderStatuses;
    r.defaultParams[1].value = exportedOrdersOnly;
    r.params.push(vendorsShowInactive);
  }
  if (r.name === "DataAnalysis_VendorCustomerSummary") {
    r.defaultParams[0].value = defaultOrderStatuses;
    r.defaultParams[1].value = exportedOrdersOnly;
    r.params.push(insideSales);
    r.params.push(vendorsShowInactive);
  }
  if (r.name === "DataAnalysis_VendorCategorySummary") {
    r.params.push(vendorsShowInactive);
  }
  if (r.name === "") {
    r.params.push(vendors);
  }
  
  r.labels = {
    customerStatuses: false,
    defaultOrderStatuses: false,
  };
}

export default Object.assign(shared, {
  customerStatuses,
  defaultOrderStatuses
});